"use strict";
/*
 * This file is part of the IVMS Online.
 *
 * @copyright 2026 © by Rafał Wrzeszcz - Wrzasq.pl.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.useVessel = void 0;
const react_1 = require("react");
const react_router_1 = require("react-router");
const api_1 = require("../../api");
const useVessel = (query) => {
    const { vesselId } = (0, react_router_1.useParams)();
    const [vessel, setVessel] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        if (vesselId) {
            const request = api_1.api.graphql({
                query,
                variables: {
                    vesselId,
                },
            });
            request.then(response => {
                var _a;
                setVessel((_a = response.data) === null || _a === void 0 ? void 0 : _a.getVessel);
            });
            return () => {
                api_1.api.cancel(request);
            };
        }
    }, [vesselId]);
    return vessel;
};
exports.useVessel = useVessel;
